'use strict';

class AuthService {

    constructor($http, DataService, $auth, $location, $rootScope, $uibModalStack, Storage, SidenavFactory, BreadcrumbFactory, Util, timeSessionExpired, Message, $log, baseUrl) {
        "ngInject";

        this.$http = $http;
        this.DataService = DataService;
        this.$auth = $auth;
        this.$rootScope = $rootScope;
        this.$uibModalStack = $uibModalStack;
        this.$location = $location;
        this.Storage = Storage;
        this.Util = Util;
        this.Message = Message;
        this.$log = $log;
        this.SidenavFactory = SidenavFactory;
        this.BreadcrumbFactory = BreadcrumbFactory;
        this.timeSessionExpired = timeSessionExpired;
        this.baseUrl = baseUrl;
    }

    signin(data) {

        this.$auth.login(data)
        .then(response => {

            let user = response.data.user;
            let menu = response.data.menu;
            let rol = user.id_rol;
            let pathRedirect = response.data.menuEntrar;
            user.pathLogin = data.pathLogin || 'login';
            user.nit = data.nit;
            this.$rootScope.auth = true;
            // Set user
            user.pathInicio = pathRedirect;
            this.SidenavFactory.setUser(user);
            this.Storage.setUser(user);

            if (!user.nit) {
                menu = menu.filter( it => {
                    if(it.id_menu!=10) return it;
                })
            }
            if (!user.nit && rol === 4) {
                this.Storage.set('upSinNit', true);
                menu = menu.filter( it => {
                    if(it.id_menu !== 41 && it.id_menu !== 44 ) return it;
                })
            }

            // Set Menu
            this.SidenavFactory.setMenu(menu);
            this.Storage.set('menu', this.SidenavFactory.getMenu());

            // Set rol
            this.SidenavFactory.setRol(rol);
            this.Storage.set('rol', this.SidenavFactory.getRol());

            // Validaciones para el usuario EMPRESARIO
            if (user.estado == 'ACTIVO') {
                pathRedirect = response.data.menuEntrar ? response.data.menuEntrar : 'matricula';
                data.menu = true;
                data.sidenav = true;
            }

            if (user.estado == 'PENDIENTE') {
                if(user.id_rol === 4) {
                    pathRedirect = 'inscripcion';
                } else {
                    pathRedirect = 'inscripcion';
                }
            }

            // Set Visible
            this.SidenavFactory.setVisible(data.menu === undefined ? true : data.menu);
            this.Storage.set('visible', this.SidenavFactory.getVisible());

            // Set Sidenav
            this.SidenavFactory.setSidenav(data.sidenav === undefined ? true : data.sidenav);
            this.Storage.set('sidenav', this.SidenavFactory.getSidenav());

            let path = pathRedirect || this.Storage.get('path');

            if (path) {
                let route = path.replace('/', '');

                // Set breadcrumb
                let page = this.Util.getMenuOption(this.Storage.get('menu'), route);
                this.BreadcrumbFactory.setParent(page[0]);
                this.BreadcrumbFactory.setCurrent(page[1]);
            }

            this.timerSession();

            // Redirect to dashboard
            this.$location.path(path && path.indexOf('login') == -1? path : (data.path || '/'));
        }).catch(error => {
            if (error.data && error.data.mensaje) {
                this.Message.error(error.data.mensaje);
            } else if (error && error.status === -1) {
              this.Message.error('No se pudo establecer conexión con el servidor.');
            } else {
              this.Message.error('Los datos ingresados son incorrectos o su cuenta no está registrada.');
            }
        });
    }

    timerSession() {
        // Definiendo el tiempo en el que dura una sesión sin actividad
        angular.TIME = this.timeSessionExpired * 60;
        var ctrl = this;
        angular.sessionInterval = window.setInterval(function () {
            angular.TIME--;
            if (angular.TIME <= 0) {
                angular.expired = true;
                ctrl.logout();
            }
        }, 1000);
    }

    logout() {

        let pathLogin = 'login';
        if (this.Storage.existUser() && this.Storage.getUser() && this.Storage.getUser().pathLogin) {
            pathLogin = this.Storage.getUser().pathLogin;
        }

        this.DataService.get(`${this.baseUrl}api_v3/logout`)
        .then(() => {
            return this.$auth.logout();
        })
        .then(() => {
            if (angular.sessionInterval) {
                window.clearInterval(angular.sessionInterval);
                angular.sessionInterval = null;
            }
            setTimeout(() => {
                this.$uibModalStack.dismissAll('Cerrando sesión');
            }, 1000);
            this.Storage.removeUser();
            this.Storage.remove('menu');
            this.Storage.remove('visible');
            this.Storage.remove('rol');
            this.Storage.remove('sidenav');
            this.Storage.remove('token');
            this.Storage.remove('path');
            // Eliminando información de Probolivia
            this.Storage.remove('formulario');
            this.Storage.remove('matricula');
            this.Storage.remove('matriculas');
            this.Storage.remove('datos_matricula');
            this.Storage.remove('certificacion');
            this.Storage.remove('unidad_productiva');
            // Eliminando información de Promueve
            this.Storage.remove('matriculaPromueve');
            this.Storage.remove('matriculasPromueve');
            this.Storage.remove('producto');
            this.Storage.removeAll();
            this.SidenavFactory.setUser({});
            this.SidenavFactory.setMenu([]);
            this.SidenavFactory.setVisible(false);
            if (angular.expired) {
                this.Storage.set('expired', true);
                delete angular.expired;
            }

            this.$location.path(pathLogin);
        });
    }

    isAuthenticated () {
        return this.$auth.isAuthenticated();
    }
}

export default AuthService;



// WEBPACK FOOTER //
// ./src/app/components/admin/login/auth.service.js